import React from 'react'
import {Route, Switch} from 'react-router-dom'
import ListClients from './ListClients'
import ShowClientPage from './ShowClientPage'
import NewClientPage from './NewClientPage'
import EditClientPage from './EditClientPage'

const Clients = ({match}) => (
  <Switch>
    <Route exact path={match.url + '/'} component={ListClients} />
    <Route exact path={match.url + '/new'} component={NewClientPage} />
    <Route path={match.url + '/:id/edit'} component={EditClientPage} />
    <Route path={match.url + '/:id'} component={ShowClientPage} />
  </Switch>
)

export default Clients



// WEBPACK FOOTER //
// ./src/components/Clients/Clients.jsx